<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import Content from './PolicyDescription.vue'

const { t } = useI18n()

const dialog = ref(false)
</script>

<template>
    <v-dialog
        v-model="dialog"
        width="auto"
        transition="dialog-bottom-transition"
    >
        <template #activator="{ props }">
            <button
                class="policy-header-button"
                v-bind="props"
            >
                {{ t('dashboard_v2.policy_page.header_button') }}
            </button>
        </template>
        <Content
            @close="() => dialog = false"
        />
    </v-dialog>
</template>

<style>
    .policy-header-button {
        cursor: pointer;
        user-select: none;

        padding: 8px 12px;
        border-radius: 8px;

        font-size: 14px;
        color: rgb(var(--v-theme-mainMenuText));

        background-color: rgb(var(--v-theme-primary));
    }
</style>
